import {
    RESET_ENTRY_DETAIL_STATE,
    SAVE_ENTRY_STATE,
    FAIL_SAVE_ENTRY_STATE,
    SUCCESS_SAVE_ENTRY_STATE,
    SET_ENTRY_DETAIL_STATE,
    GET_KEIYAKU_KIGYOU_LIST,
    FAIL_GET_KEIYAKU_KIGYOU_LIST,
    SUCCESS_GET_KEIYAKU_KIGYOU_LIST,
    GET_JIGYOSHA_LIST,
    FAIL_GET_JIGYOSHA_LIST,
    SUCCESS_GET_JIGYOSHA_LIST,

    GET_KEIYAKU_KIGYOU,
    FAIL_GET_KEIYAKU_KIGYOU,
    SUCCESS_GET_KEIYAKU_KIGYOU,
    GET_BUTSURYU_BOTEN,
    FAIL_GET_BUTSURYU_BOTEN,
    SUCCESS_GET_BUTSURYU_BOTEN,
    GET_MAKER,
    FAIL_GET_MAKER,
    SUCCESS_GET_MAKER,

    FETCH_ENTRY_DETAIL_DATA,
    FAIL_FETCH_ENTRY_DETAIL_DATA,
    SUCCESS_FETCH_ENTRY_DETAIL_DATA,
    RESET_PROCESS_ERROR
} from '../actions';
import {getValueHash} from "../common/utils/array";


const init = {
    /*common*/
    isFetching: false,
    error: undefined,
    isProcessError : false,

    /*data*/
    data: [],
    headerData:{
        "DataTeikyoumotoCD":"",
        "ButsuryuBotenCD":"",
        "MakerCD":"",
        "DenpyoNO":"",
        "NohinYoteiYMD":null,
        "DenpyoYMD":null
    },
    headerDataOrg:{
        "DataTeikyoumotoCD":"",
        "ButsuryuBotenCD":"",
        "MakerCD":"",
        "DenpyoNO":"",
        "NohinYoteiYMD":null,
        "DenpyoYMD":null
    },
    keiyakukigyou: null,
    butsuryuboten:null,
    maker:null,
    DataTeikyoumotoName:'',

    /*state*/
    dialogOpen:false,
    isDuplicate:false,
    isAfterFetch:false,
    isGetKeiyakuKigyou:false,
    isGetButsuryuBoten:false,
    isGetMaker:false,

    /*master*/
    keiyakukigyouData:[],
    jigyoshaData:[]

};
const initialState = Object.assign({},init);

export default function entryDetailSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_ENTRY_DETAIL_DATA:
        case SAVE_ENTRY_STATE:
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_ENTRY_DETAIL_DATA:
        case FAIL_SAVE_ENTRY_STATE:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_FETCH_ENTRY_DETAIL_DATA:
            ret.isFetching = false;
            ret.headerData = getValueHash(action.payload.headerData);
            ret.headerDataOrg = getValueHash(action.payload.headerData);
            ret.data = action.payload.detailData;
            ret.isAfterFetch = true;
            return ret;
        case SUCCESS_SAVE_ENTRY_STATE:
            ret.isFetching = false;
            ret.isDuplicate = action.payload.isDuplicate;
            ret.dialogOpen = !action.payload.isDuplicate;
            return ret;
        case GET_KEIYAKU_KIGYOU_LIST:
        case GET_JIGYOSHA_LIST:
        case GET_KEIYAKU_KIGYOU:
        case GET_BUTSURYU_BOTEN:
        case GET_MAKER:
            ret.isFetching = true;
            return ret;
        case FAIL_GET_JIGYOSHA_LIST:
        case FAIL_GET_KEIYAKU_KIGYOU_LIST:
        case FAIL_GET_KEIYAKU_KIGYOU:
        case FAIL_GET_BUTSURYU_BOTEN:
        case FAIL_GET_MAKER:
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_GET_KEIYAKU_KIGYOU_LIST:
            ret.keiyakukigyouData = action.payload.data.map(suggestion => ({
                value: suggestion.KeiyakuKigyouCD,
                label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName,
                name : suggestion.KeiyakuKigyouName
            }));
            return ret;
        case SUCCESS_GET_JIGYOSHA_LIST:
            ret.jigyoshaData = action.payload.data;
            return ret;
        case SUCCESS_GET_KEIYAKU_KIGYOU:
            ret.isFetching = false;
            ret.keiyakukigyou = action.payload.data;
            ret.isGetKeiyakuKigyou = true;
            return ret;
        case SUCCESS_GET_BUTSURYU_BOTEN:
            ret.isFetching = false;
            ret.butsuryuboten = action.payload.data;
            ret.isGetButsuryuBoten = true;
            return ret;
        case SUCCESS_GET_MAKER:
            ret.isFetching = false;
            ret.maker = action.payload.data;
            ret.isGetMaker = true;
            return ret;
        case SET_ENTRY_DETAIL_STATE:
            return Object.assign({},state,action.payload);
        case RESET_ENTRY_DETAIL_STATE:
            Object.keys(init).forEach((key)=>{
                ret[key] = init[key];
            })
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/entry-detail.js